<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Axios from 'axios'
export default {
    name: "App",
    data(){
      return{
        adder:"",
        formInline: {
        endRegisterTime:"",
        registerAddress:'',
        version:"",
        education:"",   
        registerIpAddress:"",
        beginRegisterTime:"",
        searchType:"",
        source:"",
          sex:'',
        nickName:"",
        searchType:1,
        phone:"",
        beginAge:"",
        endAge:"",
        current: 1,
        size: 20,
        // token: localStorage.getItem('logintoken')
      }
      }
    },

    created(){
//       let tokenId= localStorage.getItem('tokenId');
//     this.adder =tokenId

//     Axios({
//   method: 'get',

//   url: 'https://platform-test.ynhlminiapp.com/api/platform-account/accountList',
//   headers:{
//           tokenId:this.adder
//         },
//   params:this.formInline
 

// })
// .then(res => {
//         // console.log(res);
//         if(res.data.code==999){
//           setTimeout(() => {
//             localStorage.removeItem('tokenId')

//             this.$store.commit('logout', 'false')
//             this.$router.push({ path: '/login' })
//             this.$message({
//               type: 'success',
//               message: '登录过期,请重新登录'
//             })
//           }, 1000)

           

          

//         }else{
//           console.log('2222');
//         }
      
//       })

  
    }
};

</script>

<style> 
html,

body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    widows: 100%;
    height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue